import { Chat } from '~/domain/interfaces/socketEvents/Chat';
import { makeReduxChatMessage } from '~/main/factories/usecases/chat/ChatMessageFactory';
// import {  } from '~/main/factories/usecases/waitingRoom/UserQueueWaitingRoomFactory';

export const ChatEvents = (data: any): void => {
  const x: Chat = data;
  makeReduxChatMessage().add(x);
};
